import React, { useMemo } from "react";

import { useNavigate, useVersionReviews } from "utils";

import { VersionReviewsTable } from "pages/admin/soilSight/components/shared/VersionReviewsTable.tsx";

export const SoilSightMultipleVersionReviews = () => {
  const { data: reviews, isLoading: isLoadingReviews } = useVersionReviews();
  const navigate = useNavigate();

  // Comparison reviews only — single-version reviews (baseline === candidate) live on the single-version page instead.
  const comparisonReviews = useMemo(() => reviews?.filter((r) => r.baselineVersion !== r.candidateVersion), [reviews]);

  const openComparison = (record: { baselineVersion: string; candidateVersion: string }) =>
    navigate({
      pathname: "/soil-sight-multiple-version/comparison",
      search: `?baseline=${encodeURIComponent(record.baselineVersion)}&candidate=${encodeURIComponent(record.candidateVersion)}`,
    });

  return (
    <VersionReviewsTable
      reviews={comparisonReviews}
      isLoading={isLoadingReviews}
      description="Comparisons reviewed by admins, grouped by version pair"
      groupLabel={(review) => `${review.baselineVersion} → ${review.candidateVersion}`}
      detailLabel={(review) => (
        <>
          {review.baselineVersion} (baseline) vs {review.candidateVersion} (candidate)
        </>
      )}
      openTooltip="Open in comparison view"
      onOpen={openComparison}
    />
  );
};
